module.exports = __webpack_public_path__ + "img/homepage-content-image-toyota.357e7d25.jpg";